import React, { Component } from "react";
import { connect } from "react-redux";

class CartOptions extends Component {
  render() {
    const language = this.props.language;
    const options = [];
    for (var group in this.props.product.options) {
      let OptionGroup = this.props.originalProduct.options.find(
        (optionGroup) => optionGroup.id === parseInt(group)
      );
      let choice = undefined;
      options.push(
        <p
          key={`Drawer OptionGroup ${OptionGroup.name} ${OptionGroup.id}`}
          className="text-muted m-0 px-2"
          style={{ fontSize: this.props.cart ? "0.8rem" : "0.95rem" }}
          dir={language == "english" ? "ltr" : "rtl"}
        >
          <span style={{ fontWeight: 600 }}>
            {language == "english" ? OptionGroup.name : OptionGroup.ar_name}:{" "}
          </span>
          {Object.keys(this.props.product.options[group].selectedOptions).map(
            (key, indx) => {
              choice = OptionGroup.choices.find((option) => option.id == key);

              return (
                <span key={`CartProductOption ${choice.value} ${choice.id}`}>
                  {language == "english" ? choice.value : choice.ar_value}
                  {indx ==
                  Object.keys(this.props.product.options[group].selectedOptions)
                    .length -
                    1
                    ? ""
                    : ", "}
                </span>
              );
            }
          )}
        </p>
      );
    }
    return (
      <div
        className="ml-2"
        style={{
          textAlign: this.props.centerItems
            ? "center"
            : language === "arabic"
            ? "right"
            : "left",
        }}
      >
        {options}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};

export default connect(mapStateToProps)(CartOptions);
